import React, { useState } from 'react';
import { Link } from 'gatsby';
import get from 'lodash/get';
import CommonInput from './CommonInput';
import UploadImgComponent from '../CommonComponent/UploadImgComponent';
import UploadView from './UploadView';

import { useCheckFileAndUpdateError } from '../AddressProof/checkFileUploadCriteria';

const UploadOptionsDetails = props => {
  const {
    gassbillImgUrl,
    setstepsInfo,
    data,
    setData,
    options,
    handleChange,
    name,
    setFileUploadErrors,
    fileUploadErrors,
    errors,
    touched,
    setTouched
  } = props;
  const fileCheck = useCheckFileAndUpdateError({
    data,
    fileUploadErrors,
    setFileUploadErrors,
    name
  });
  function onChange(imgUrl, files) {
    data.utilityBill.files = files;
    data.utilityBill.imgUrl[0] = imgUrl;

    setData({
      ...data,
      utilityBill: {
        ...data.utilityBill,
        imgUrl: data.utilityBill.imgUrl,
        files: data.utilityBill.files
      }
    });

    fileCheck(files); // start valiodation from here
  }

  return (
    <>
      <div className="flex flex-col flex-wrap w-full">
        <div
          className=" bg-white flex-col lg:px-2 w-full  py-8 flex lg:flex-row 
      justify-around items-center  sm:flex-col"
        >
          <div
            style={{
              minWidth: '300px'
            }}
          >
            {options &&
              options.map((elem, index) => {
                const {
                  place_holder,
                  type,
                  id,
                  disabled,
                  value,
                  onChange,
                  onBlur,
                  name
                } = elem;

                return (
                  <CommonInput
                    key={id}
                    name={name}
                    value={value}
                    type={type}
                    stylesContainer={{
                      marginBottom: '30px'
                    }}
                    onChange={e => {
                      if (onChange) {
                        onChange(e);
                      }
                    }}
                    onBlur={e => {
                      // handleBlur(e);
                      if (onBlur) {
                        onBlur(e);
                      }
                    }}
                    disabled={disabled}
                    legendName={place_holder}
                    // placeholder="Address"
                    error={
                      disabled
                        ? false
                        : get(errors, name, false) && get(touched, name, false)
                    }
                    errorMsg={disabled ? '' : get(errors, name, false)}
                    touched={disabled ? false : get(touched, name, false)}
                  />
                );
              })}
          </div>
          <div>
            <div
              className="shadow-md"
              style={{ padding: '24px 24px 3px 24px' }}
            >
              <img
                style={{ width: '178px', height: '112px' }}
                src={gassbillImgUrl}
                onClick={e => {
                  if (gassbillImgUrl) {
                    window.open(gassbillImgUrl, '_blank');
                  }
                }}
                alt=""
                className="cursor-pointer"
              />
              <UploadImgComponent onChange={onChange}>
                <p
                  className="underline text-black-800 text-xs"
                  style={{ position: 'relative', top: '30px' }}
                >
                  Re-upload
                </p>
                {/* ///////show error here//////// */}

                {/* /////////// */}
              </UploadImgComponent>
            </div>
            <p className="for-error">
              {get(touched, 'utilityBill.files', false) &&
                get(fileUploadErrors, 'utilityBill.files', false) && (
                  <p
                    className="text-red-100"
                    style={{
                      width: '225px',
                      height: '112px',
                      position: 'relative',
                      top: '29px'
                    }}
                  >
                    {fileUploadErrors['utilityBill.files']}
                  </p>
                )}
            </p>
          </div>
        </div>

        <div className="md:block text-center w-full  mt-6">
          <button
            type="submit"
            disabled={errors.utilityBill?.utilityBillDetails?.address || false}
            className="w-1/2 md:w-1/4 submitButton "
          >
            CONTINUE
          </button>
        </div>
      </div>
    </>
  );
};

export default UploadOptionsDetails;
